'use client'

import { useRouter } from 'next/navigation'
import { useState } from 'react'
import Image from 'next/image'
import { useAuthStore } from '@/stores'
import { useBuilderUnsavedCheck } from '@/hooks/useBuilderUnsavedCheck'
import { ConfirmationDialog } from '@/components/ui/Dialog'

export default function Logo() {
  const router = useRouter()
  const { isAuthenticated } = useAuthStore()
  const { hasUnsavedBuilderChanges } = useBuilderUnsavedCheck()
  const [isUnsavedModalOpen, setIsUnsavedModalOpen] = useState(false)
  const href = isAuthenticated ? '/invitations' : '/'

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    // Check if builder has unsaved changes in localStorage
    if (hasUnsavedBuilderChanges()) {
      setIsUnsavedModalOpen(true)
      return
    }

    router.push(href)
  }

  const confirmNavigation = () => {
    setIsUnsavedModalOpen(false)
    // BuilderStorageCleanup will handle clearing the storage on route change
    router.push(href)
  }

  return (
    <>
      <a
        href={href}
        onClick={handleClick}
        className="no-underline cursor-pointer inline-flex items-center h-14"
      >
        <div className="h-10 relative w-[80px] mt-2">
          <Image
            src="/images/logo.png"
            alt="DDay Logo"
            fill
            sizes="80px"
            priority
            className="object-contain"
          />
        </div>
      </a>

      {/* Unsaved Changes Confirmation Modal */}
      <ConfirmationDialog
        isOpen={isUnsavedModalOpen}
        onClose={() => setIsUnsavedModalOpen(false)}
        onConfirm={confirmNavigation}
        title="Unsaved Changes"
        description="You have unsaved changes that will be lost. Do you want to leave without saving?"
        confirmText="Leave"
        cancelText="Stay"
        variant="warning"
      />
    </>
  )
}
